<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "App",
};
</script>

<style>
* {
  margin: 0 0;
}
html,
body,
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  width: 100%;
  height: 100%;
}
.general {
  width: 100%;
  padding-top: 40px;
}
.general .general-content {
  width: 952px;
  margin: 0 auto;
  margin-bottom: 40px;
}

.item-title {
  color: #242b43;
  font-size: 30px;
  font-weight: 600;
  margin-bottom: 40px;
  text-align: center;
}
.index-top {
  display: flex;
  justify-content: center;
  margin-bottom: 10px;
  position: relative;
}
.banner-text {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: #fff;
}
.banner-text h1 {
  margin-bottom: 30px;
}
.banner-text p {
  line-height: 30px;
  font-size: 20px;
}
.banner-text div {
  background-color: rgb(38, 89, 230);
  width: 200px;
  text-align: center;
  line-height: 40px;
  margin-top: 20px;
}
.videoBg {
  width: 100%;
}
video {
  display: block;
}
@media screen and (max-width: 1000px) {
  .general .general-content {
    width: 95%;
    margin-bottom: 10px;
  }

  .banner-text h1 {
    margin-bottom: 10px;
  }
  .banner-text p {
    line-height: 22px;
    font-size: 14px;
  }
  .banner-text div {
    width: 200px;
    line-height: 30px;
    margin-top: 20px;
    font-size: 10px;
  }
}

@media screen and (max-width: 768px) {
  .general {
    padding-top: 20px;
  }
  .general .general-content {
    width: 90%;
    margin-bottom: 10px;
  }
  .item-title {
    font-size: 24px;
    margin-bottom: 20px;
  }
  .banner-text {
    width: 90%;
  }
  .banner-text h1 {
    margin-bottom: 5px;
    font-size: 12px;
  }
  .banner-text p {
    line-height: 15px;
    font-size: 8px;
  }
  .banner-text div {
    width: 80px;
    line-height: 20px;
    margin-top: 5px;
  }
}
</style>
